<template>
  <div v-if="showSuction" class="suction_bottom" :style="fontFamily ? { fontFamily: `'${fontFamily}', sans-serif` } : null">
    <div class="wrapper">
      <div class="description" :style="fontFamily ? { fontFamily: `'${fontFamily}', sans-serif` } : null">
        {{ copywriting }}
      </div>
      <div class="button_content">
        <div v-for="(item, index) in dataList" :key="index" class="button btn-primary" :style="fontFamily ? { fontFamily: `'${fontFamily}', sans-serif` } : null" @click="handleAccept(item)">
          {{ item.buttonCopywriting }}
        </div>
      </div>
    </div>
    <div class="close_btn" @click="closeShowSuction" />
  </div>
</template>

<script>
import mixin from './mixin';
import bus from 'common/bus'
import injectSourceToUrl from 'common/sourceInject'
import trackReportMixin from '../Common/CommonMixin/trackReport'
import { getShowSuctionState, setShowSuctionState } from 'common/utils.js';
import dataReport from 'common/dataReport';

export default {
  mixins: [mixin, trackReportMixin],
  data() {
    return {
      showSuction: false,
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
  },
  mounted() {
    this.showSuction = getShowSuctionState(this.$route.path)
  },
  methods: {
    closeShowSuction() {
      setShowSuctionState(this.$route.path)
      this.showSuction = false
    },
    handleAccept(item) {
      try {
        dataReport.launchReport({
          fbqOptions: {
            name: 'EvalStartClick',
            params: {
              path: this.$route.path,
            },
          },
        });
      } catch (error) {
        // ignore
      }
      window?.dataLayer?.push({
        event: 'LP_bottom_click',
        user_id: this.$store.state.ucenter?.user?.uid || 'non-login',
        button_name: item.buttonCopywriting,
      })
      if (item.skip === '_blank') { // 功能性跳转
        // 埋点上报
        this.buttonTrackReport({
          buttonName: item.feature === 'triageDesk' ? 'triageDesk' : 'toShowDiagnosis',
        });
        if (item.feature === 'triageDesk') {
          if (!this.$store.state.signupEntranceTriage) {
            const successUrl = `/triage-desk/${item.triageComponentId}`
            if (!this.isLogin) {
              bus.$emit('login', { successUrl, triggerSource: 'down' })
              return
            }
            if (item.triageComponentId) this.$router.push(successUrl)
            return
          }
          if (item.triageComponentId) this.$router.push(`/new-triage-desk/${item.triageComponentId}`)
          return
        }
        if (!this.isLogin) {
          bus.$emit('login', { triggerSource: 'appointment' });
          return
        }
        bus.$emit('toShowDiagnosis')
      }
      if (item.skip === '_self') { // 自定义链接跳转
        const processedLink = injectSourceToUrl(item.skipLink);
        if (item.skipWay === '_blank') { // 在当前页面打开
          window.location.href = processedLink;
        }
        if (item.skipWay === '_self') { // 在新标签页打开
          window.open(processedLink, '_blank');
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .close_btn {
    position: absolute;
    top: 50%;
    right: 20px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    background: url("./image/icon_close.png") no-repeat;
    background-size: contain;
    cursor: pointer;
  }

  .suction_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 64px;
    background: var(--txt-color-link);

    .wrapper {
      position: relative;
      display: flex;
      justify-content: space-between;
    }

    .description {
      max-width: 980px;
      line-height: 64px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
      font-family: 'Montserrat-SemiBold', 'Montserrat', sans-serif;
      font-weight: 600;
      color: #fff;
    }

    .button_content {
      display: flex;
    }

    .button {
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      cursor: pointer;
      margin-top: 12px;
      background: #fff;
      font-size: 16px;
      font-family: 'PingFangSC-Semibold', 'PingFang SC', sans-serif;
      font-weight: 600;
      color: var(--txt-color-link);
      margin-left: 10px;
      margin-right: 10px;
      padding-left: 49px;
      padding-right: 49px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
